export default {"src":"/_next/static/media/caret-left-gray.6ab1cefb.svg","height":16,"width":16};